import { render, staticRenderFns } from "./ZisPaymentOption.vue?vue&type=template&id=2af13678"
import script from "./ZisPaymentOption.vue?vue&type=script&lang=js"
export * from "./ZisPaymentOption.vue?vue&type=script&lang=js"
import style0 from "./ZisPaymentOption.vue?vue&type=style&index=0&id=2af13678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports